export const UrlConstants = {
  // 社名アイコンURL
  COMPANY_ICON_URL: 'page0001',

  // よくある質問URL
  FAQ_URL: 'page0002',

  // <総合>みらいリッチURL
  MIRAI_RICH_URL: 'page0004',

  //「ご契約のしおり」「約款」URL
  CONTRACT_DOCUMENT_URL: 'page0007',

  // ご契約者専用サイトのご利用時間
  CONTRACTOR_SITE_AVAILABLE_TIME_URL: 'page0003',

  // ファンド選定ツール
  FUND_SELECTION_TOOL_URL: 'page0005',

  // 特別勘定運用ポータル
  SPECIAL_ACCOUNT_OPERATION_PORTAL_URL: 'page0006',

  // 個人情報の利用目的
  PERSONAL_INFO_USAGE_URL: 'page0008',
};
